export const millingJob = {
    "SIMPLE": "Простая",
    "DIFFICULT": "Сложная",
}